import { revalidarCatalogosAposEscrita } from '@/integracoes/src-next/catalogos/revalidar-apos-escrita'
import i18n from 'src/typescript/servicos/i18n/i18n.servico'
import { resetarParaEstadoInicial } from 'src/utils/executoras/executoras'
import { API } from 'src/services'
import { converteObjetoDoBackParaVuex } from './converteObjetoDoBackParaVuex'
import { formataObjetoParaEnviar } from './formataObjetoParaEnviar'
import {
  OPCOES_DE_APONTAMENTOS,
  VALOR_PADRAO_LIMITE_HORAS_TRABALHADAS,
  VALOR_PADRAO_JORNADA_BASE
} from './limiteDeAcumuloPorHorasTrabalhadas'
import {
  OPCOES_DE_TIPO_DE_ACUMULO_DA_BAIXA_DE_BH,
  OPCOES_DE_TIPO_DE_COMPENSACAO_DA_BAIXA_DE_BH
} from './compensacaoEmOrdem'

import {
  vuexMapDefaultsMutations,
  vuexMapDefaultsActions,
  vuexMapDefaultsGetters
} from 'src/utils.store'

function defaultState () {
  return {
    id: null,
    carregandoRegra: false,
    // Cabeçalho
    nome: '',
    codigo: '',
    dataInicioDoBanco: null,
    limiteDeAcumuloDoBanco: 90,
    limiteDeMesesDeAcumuloDoBanco: 0,
    usaConfiguracaoDeVencimentoPorMeses: false,
    vencimentoUnificado: false,
    tipoDeContagemDeTempo: {
      selected: {id: 'fixo', name: i18n.t('hourBankRules.details.state.comuns.tipoContagemDeTempo.fixo')},
      loaded: [
        {id: 'fixo', name: i18n.t('hourBankRules.details.state.comuns.tipoContagemDeTempo.fixo')},
        {id: 'movel', name: i18n.t('hourBankRules.details.state.comuns.tipoContagemDeTempo.movel')}
      ]
    },
    modalidadeDoBanco: {
      selected: {id: 'geral', name: i18n.t('hourBankRules.DetalhesDaTabela.opcoesSelecao.compensacaoGeral')},
      loaded: [
        {id: 'geral', name: i18n.t('hourBankRules.DetalhesDaTabela.opcoesSelecao.compensacaoGeral')},
        {id: 'janela', name: i18n.t('hourBankRules.comuns.modalidadesDoBanco.compensacaoJanela')}
      ]
    },
    tipoDoCicloDeAutoCompensacao: {
      loaded: [
        {id: 'month', name: i18n.t('hourBankRules.details.state.comuns.opcoesAutoCompensacao.mensal')},
      ],
      selected: {id: 'month', name: i18n.t('hourBankRules.details.state.comuns.opcoesAutoCompensacao.mensal')}
    },
    quantosCiclosParaVencimento: 6,
    permitirDescontoEmSaldosVencidos: false,
    // FatorDeTransformacaoDeHoras
    fatorDeTransformacaoDeHoras: Array(10).fill(1.0),
    // RazaoDeAcumuloECompensacao
    usaRazaoDeAcumuloECompensacao: false,
    razaoDeAcumuloECompensacao: Array(10).fill(100),
    // CompensacaoEmOrdem
    usaCompensacaoEmOrdem: false,
    separarHorasExtrasDeSobreavisoNaCompensacaoEmOrdem: false,
    tipoDeAcumuloDaBaixaDeBh: {
      loaded: OPCOES_DE_TIPO_DE_ACUMULO_DA_BAIXA_DE_BH,
      selected: []
    },
    tipoDeCompensacaoDaBaixaDeBh: {
      loaded: OPCOES_DE_TIPO_DE_COMPENSACAO_DA_BAIXA_DE_BH,
      selected: []
    },
    // LimitesDiarios
    usaLimiteDiario: false,
    limiteDeAcumuloECompensacaoDiario: Array(10).fill(null),
    limiteBaseDeAcumuloECompensacaoDiario: [0, 0, 0, -1, 0, 0, 0, 0, -1, -1],
    limiteDeAcumuloPorHorasTrabalhadas: {
      seletor: {
        loaded: OPCOES_DE_APONTAMENTOS,
        selected: []
      },
      valor: VALOR_PADRAO_LIMITE_HORAS_TRABALHADAS,
      jornadaBase: VALOR_PADRAO_JORNADA_BASE
    },
    // LimitesSemanais
    usaLimiteSemanal: false,
    limiteDeAcumuloECompensacaoSemanal: Array(10).fill(null),
    limiteBaseDeAcumuloECompensacaoSemanal: [0, 0, 0, -1, 0, 0, 0, 0, -1, -1],
    // LimitesMensais
    usaLimiteMensal: false,
    limiteDeAcumuloECompensacaoMensal: Array(10).fill(null),
    limiteBaseDeAcumuloECompensacaoMensal: [0, 0, 0, -1, 0, 0, 0, 0, -1, -1],
    // LimitesMensaisSobreaviso
    usaLimiteMensalSobreaviso: false,
    limiteMensalSobreaviso: Array(6).fill(null),
    gruposDeLimiteSobreaviso: [],
    // LimitesGerais
    usaLimiteGeral: false,
    calcularLimitesUtilizandoSaldosFuturos: false,
    limiteDeAcumuloECompensacaoGeral: Array(10).fill(null),
    limiteBaseDeAcumuloECompensacaoGeral: [0, 0, 0, -1, 0, 0, 0, 0, -1, -1],
    // OutrasConfiguracoes
    acumularHorasAutomaticamente: true,
    compensarHorasAutomaticamente: true,
    permitirBalancoNegativo: true,
    aprovacaoAutomatica: true,
    separarCompensacaoEAcumulo: false,
    considerarAcumuloParcialDeHoras: false,
    considerarBaixaComTmsComoCompensacao: false,
    descontarBancoSemExibirNaFolha: false,
    exibirBaixaDeBhSeparadaPorCategorias: false,
    removerApontamentosDaLinha: false,
    compensateOnLock: true,
    fazerBaixaNoVencimentoDoBanco: false,
    completarVisualizacaoDoAcumuladoComJanelasFalsas: true,
    mostrarHistoricoDosSaldosNoAcumuladoDeBancoDeHoras: false,
    mudaNomenclaturaParaCompensacaoNaFolha: false,
    exibirFaltaComoCompensadaNoR01: false,
    considerarHorasRelogioNoCalculoDeLimiteSemanal: false,
    // ConfiguracoesAvancadas
    usarGatilhoDeSaldoGeral: false,
    gatilhoLimiteGeral: 100,
    usarGatilhoDeSaldoMensal: false,
    gatilhoBaseMensal: 50,
    camposDesconsideradosDoGatilhoMensal: []
  }
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState())
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetarParaEstadoInicial(state, defaultState())
  },
  setFromState (state, {...company}) {
    Object.assign(state, company)
  },
  carregandoRegra (state, payload) {
    state.carregandoRegra = payload
  }
}

const actions = {
  ...vuexMapDefaultsActions(defaultState()),
  async loadWhbRules ({ commit }, whbRuleId) {
    commit('carregandoRegra', true)

    const api = await API.whbRules.get({id: whbRuleId})

    commit('setFromState', {
      ...converteObjetoDoBackParaVuex(api.data.success[0])
    })

    commit('carregandoRegra', false)
  },
  async save ({ state, dispatch }) {
    const ehEdicao = Boolean(state.id)
    const info = formataObjetoParaEnviar(state)
    await API.whbRulesSave.save({}, info)
    if (ehEdicao) revalidarCatalogosAposEscrita(dispatch, ['employees'])
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
